import { useContext, useMemo } from 'react';

import {
  useCustomerLevelVariables,
  useAccountLevelVariables,
  usePostponeReadVariables,
} from '@bingads-webui-campaign-react/up-data';
import {
  useAccount,
  useCustomer,
  useUser,
} from '@bingads-webui/overreact-cc';
import { usePromisify } from '@bingads-webui-react/overreact';
import { promiseLogWrapper } from '@bingads-webui-campaign-react/smart-component-util';

import { InstrumentationServiceContext } from '../instrumentation-context';

export const useUserAccountCustomer = ({ postponeRead, componentName = 'SmartPageApp' }) => {
  const logger = useContext(InstrumentationServiceContext);
  const accountLevelVariables = useAccountLevelVariables();
  const customerLevelVariables = useCustomerLevelVariables();
  const postponeReadConfig = usePostponeReadVariables();

  const [{ data: user }, { update: updateUserOR, read: readUserOR }] =
    useUser(customerLevelVariables, postponeRead && postponeReadConfig);
  const [{ data: account }, { update: updateAccountOR, read: readAccountOR }] =
    useAccount(accountLevelVariables, postponeRead && postponeReadConfig);
  const [{ data: customer }, { update: updateCustomerOR, read: readCustomerOR }] =
    useCustomer(customerLevelVariables, postponeRead && postponeReadConfig);

  const [
    updateUser,
    updateAccount,
    updateCustomer,
    readUser,
    readAccount,
    readCustomer,
  ] = usePromisify([
    updateUserOR,
    updateAccountOR,
    updateCustomerOR,
    readUserOR,
    readAccountOR,
    readCustomerOR,
  ]);

  const updateUserWithLog = useMemo(() => promiseLogWrapper(updateUser, logger, 'updateUser', componentName), [componentName, logger, updateUser]);
  const updateAccountWithLog = useMemo(() => promiseLogWrapper(updateAccount, logger, 'updateAccount', componentName), [componentName, logger, updateAccount]);
  const updateCustomerWithLog = useMemo(() => promiseLogWrapper(updateCustomer, logger, 'updateCustomer', componentName), [componentName, logger, updateCustomer]);
  const readUserWithLog = useMemo(() => promiseLogWrapper(readUser, logger, 'readUser', componentName), [componentName, logger, readUser]);
  const readAccountWithLog = useMemo(() => promiseLogWrapper(readAccount, logger, 'readAccount', componentName), [componentName, logger, readAccount]);
  const readCustomerWithLog = useMemo(() => promiseLogWrapper(readCustomer, logger, 'readCustomer', componentName), [componentName, logger, readCustomer]);

  return {
    user,
    account,
    customer,

    updateUser,
    updateAccount,
    updateCustomer,
    readUser,
    readAccount,
    readCustomer,

    updateUserWithLog,
    updateAccountWithLog,
    updateCustomerWithLog,
    readUserWithLog,
    readAccountWithLog,
    readCustomerWithLog,
  };
};
